<div class="combo-box-container" [class.disabled]="disabled">
    <input
        *ngIf="inputId"
        [id]="inputId"
        type="text"
        class="sr-only"
        tabindex="-1"
        readonly
        [value]="getDisplayText()"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledby"
        (focus)="onLabelProxyFocus()"
    />

    <!-- Main input area -->
    <div
        #comboTrigger
        class="combo-box-input input input--primary"
        [class]="inputClass"
        [class.input--error]="showError"
        [class.open]="isOpen"
        [class.has-value]="selectedOptions.length > 0"
        [class.error]="showError"
        [attr.role]="'combobox'"
        [attr.aria-expanded]="isOpen"
        [attr.aria-haspopup]="'listbox'"
        [attr.aria-controls]="inputId ? inputId + '-listbox' : null"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledby"
        [attr.tabindex]="disabled ? -1 : 0"
        (click)="toggleDropdown()"
    >
        <!-- Selected items display for multi-select -->
        <div class="selected-items" *ngIf="multiSelect && selectedOptions.length > 0">
            <span
                class="selected-item"
                *ngFor="let option of selectedOptions; trackBy: trackByValue"
                [title]="option.label"
            >
                <span class="selected-item-label">{{ option.label }}</span>
                <button
                    type="button"
                    class="remove-item"
                    (click)="removeOption(option, $event)"
                    [attr.aria-label]="'Remove ' + option.label"
                >
                    <lucide-icon [img]="X" class="w-4 h-4"></lucide-icon>
                </button>
            </span>
        </div>

        <!-- Display text for single select -->
        <div class="display-text" [class.wrap-text]="allowTextWrap" *ngIf="!multiSelect && selectedOptions.length > 0">
            {{ selectedOptions[0].label }}
        </div>

        <!-- Placeholder when no selection -->
        <div class="placeholder-text" *ngIf="selectedOptions.length === 0">
            {{ placeholder }}
        </div>

        <!-- Actions -->
        <div class="combo-box-actions">
            <!-- Clear button -->
            <button
                type="button"
                class="clear-button"
                *ngIf="clearable && selectedOptions.length > 0 && !disabled"
                (click)="clearSelection($event)"
                [attr.aria-label]="'Clear selection'"
            >
                <lucide-icon [img]="X" class="w-4 h-4"></lucide-icon>
            </button>

            <!-- Loading spinner -->
            <div class="loading-spinner" *ngIf="isLoading || loading">
                <lucide-icon [img]="LoaderCircle" class="w-4 h-4 text-primary animate-spin"></lucide-icon>
            </div>

            <!-- Dropdown arrow -->
            <lucide-icon
                [img]="ChevronDown"
                class="w-4 h-4 text-primary dropdown-arrow"
                [class.flipped]="isOpen"
            ></lucide-icon>
        </div>
    </div>

    <!-- Dropdown menu -->
    <div
        #dropdown
        class="dropdown-menu"
        [id]="inputId ? inputId + '-listbox' : null"
        [attr.role]="'listbox'"
        [class.open]="isOpen"
        [style.max-height]="maxHeight"
    >
        <!-- Search input inside dropdown -->
        <div class="dropdown-search" *ngIf="searchable && isOpen">
            <input
                #searchInput
                type="text"
                class="dropdown-search-input"
                [formControl]="searchControl"
                [placeholder]="'Search...'"
                autocomplete="off"
                spellcheck="false"
                (click)="$event.stopPropagation()"
            />
        </div>

        <!-- Loading state -->
        <div class="dropdown-item loading-item" *ngIf="isLoading || loading">
            <div class="spinner"></div>
            {{ loadingText }}
        </div>

        <!-- No results -->
        <div
            class="dropdown-item no-results"
            *ngIf="!isLoading && !loading && filteredOptions.length === 0 && searchControl.value"
        >
            {{ noResultsText }}
        </div>

        <!-- Options list -->
        <div class="options-list" *ngIf="!isLoading && !loading && filteredOptions.length > 0">
            <div
                class="dropdown-item option-item"
                *ngFor="let option of filteredOptions; trackBy: trackByValue"
                [class.selected]="isOptionSelected(option)"
                [class.disabled]="option.disabled"
                [attr.aria-selected]="isOptionSelected(option)"
                [attr.role]="'option'"
                (click)="selectOption(option)"
            >
                <!-- Checkbox for multi-select -->
                <input
                    type="checkbox"
                    class="option-checkbox"
                    *ngIf="multiSelect"
                    [checked]="isOptionSelected(option)"
                    [disabled]="option.disabled"
                    readonly
                    tabindex="-1"
                />

                <!-- Option label -->
                <span class="option-label" [title]="option.label">
                    {{ option.label }}
                </span>

                <!-- Selected indicator for single select -->
                <lucide-icon
                    *ngIf="!multiSelect && isOptionSelected(option)"
                    [img]="Check"
                    class="self-center w-4 h-4 text-primary"
                ></lucide-icon>
            </div>
        </div>
    </div>

    <!-- Screen reader support -->
    <div class="sr-only" aria-live="polite" aria-atomic="true">
        <span *ngIf="isLoading || loading">{{ loadingText }}</span>
        <span *ngIf="filteredOptions.length === 0 && searchControl.value">{{ noResultsText }}</span>
        <span *ngIf="selectedOptions.length > 0">
            {{ multiSelect ? selectedOptions.length + " items selected" : selectedOptions[0].label + " selected" }}
        </span>
    </div>
</div>
